/* t22-korg.js — varukorgen i tema 22, spår 6 (Sadams val 2026-10-07 14:51, bekräftat 2026-10-08).
   Byggnot: 02 - Haraka/Nya hemsidan/Varukorg i tema 22 Byggnot.md. Prototyp: teman/t26-varukorg-kassa.html.
   Dawns cart.js och cart-drawer.js sköter antal, Ta bort, öppna och stäng. Här ligger bara det som
   prototypen har utöver Dawn:
   1. "Borttagen: X. Ångra" efter Ta bort (eller minus till noll); Ångra lägger tillbaka samma antal.
   2. Dragspelets öppna delar står kvar när sidan ritas om efter en antalsändring.
   3. "Se vad som passar" fäller ut Köp 2-förslagen (fylls av assets/ha-kop2.js).
   4. Raden "Tillagd: märke namn, storlek X." överst i lådan efter Lägg i korg (ur svaret från /cart/add.js). */
(function () {
  'use strict';
  if (window.T22Korg) return;
  window.T22Korg = true;

  var bort = null; // { id, antal, namn, plats }
  var oppna = { summa: true };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* 1. Ta bort och Ångra */
  document.addEventListener('click', function (e) {
    var knapp = e.target.closest('[data-t22c-bort]');
    var minus = e.target.closest('.t22c-antal button[name="minus"]');
    var rad = (knapp || minus) && (knapp || minus).closest('.t22c-rad');
    if (!rad) return;
    var info = rad.querySelector('[data-t22c-bort]');
    if (!info) return;
    if (minus) {
      var input = rad.querySelector('.quantity__input');
      if (!input || parseInt(input.value, 10) !== 1) return;
    }
    bort = {
      id: Number(info.getAttribute('data-variant')),
      antal: knapp ? Number(info.getAttribute('data-antal')) || 1 : 1,
      namn: info.getAttribute('data-namn') || 'varan',
      plats: rad.closest('cart-drawer') ? 'lada' : 'sida'
    };
  }, true);

  function bortRad() {
    document.querySelectorAll('.t22c-bortrad').forEach(function (r) { r.remove(); });
    if (!bort) return;
    var html = '<div class="t22c-bortrad" role="status">Borttagen: ' + esc(bort.namn) + '.<button type="button" data-t22c-angra>Ångra</button></div>';
    var mal;
    if (bort.plats === 'lada') {
      mal = document.querySelector('cart-drawer [data-t22c-bortplats]') || document.querySelector('cart-drawer .drawer__inner-empty');
      if (mal && mal.matches('.drawer__inner-empty')) { mal.insertAdjacentHTML('afterbegin', html); return; }
    } else {
      mal = document.querySelector('cart-items [data-t22c-bortplats]');
    }
    if (mal) mal.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-t22c-angra]');
    if (!b || !bort) return;
    e.preventDefault();
    b.disabled = true;
    b.textContent = 'Lägger tillbaka …';
    var drawer = document.querySelector('cart-drawer');
    var iLadan = bort.plats === 'lada' && drawer && typeof drawer.renderContents === 'function';
    var body = { items: [{ id: bort.id, quantity: bort.antal }] };
    if (iLadan) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'fel');
        bort = null;
        if (!iLadan) { window.location.reload(); return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 't22-korg', cartData: res });
        }
      })
      .catch(function () {
        b.disabled = false;
        b.textContent = 'Ångra';
      });
  });

  /* 2. Dragspelet */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('details[data-t22c-del]')) return;
    oppna[d.getAttribute('data-t22c-del')] = d.open;
  }, true);

  function aterstall() {
    document.querySelectorAll('details[data-t22c-del]').forEach(function (d) {
      var k = d.getAttribute('data-t22c-del');
      if (k in oppna) d.open = oppna[k];
    });
  }

  /* 3. Köp 2-förslagen */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-t22c-k2-visa]');
    if (!b) return;
    var lista = document.getElementById(b.getAttribute('aria-controls'));
    if (!lista || !lista.querySelector('[data-ha-k2-item]')) {
      b.hidden = true; // inga förslag kom (ha-kop2.js tar bort listan), länken leder ingenstans
      return;
    }
    var visa = lista.hidden;
    lista.hidden = !visa;
    b.setAttribute('aria-expanded', visa ? 'true' : 'false');
    b.textContent = visa ? 'Dölj förslagen' : 'Se vad som passar';
  });

  /* 4. "Tillagd: ..." i lådan */
  function tillagdText(res) {
    var rad = res && (res.items && res.items.length ? res.items[0] : res);
    if (!rad || !rad.product_title) return '';
    var namn = String(rad.product_title);
    if (rad.vendor && namn.indexOf(rad.vendor) === 0) namn = namn.slice(rad.vendor.length).trim();
    namn = namn.replace(/^vattentät\s+/i, '').replace(/\s+vattentät\s+/gi, ' ').split(',')[0];
    namn = namn.charAt(0).toUpperCase() + namn.slice(1);
    var text = 'Tillagd: ' + (rad.vendor ? rad.vendor + ' ' : '') + namn;
    var opt = (rad.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; });
    if (opt.length) text += ', ' + opt.map(function (o) { return o.name.toLowerCase() + ' ' + o.value; }).join(', ');
    return text + '.';
  }

  /* Efter ett köp ritar Dawns cart.js om lådans innehåll en gång till (onCartUpdate i cart-drawer-items),
     så texten sparas och sätts tillbaka varje gång lådan ritas om, tills lådan stängs. */
  var senaste = '';
  function visaTillagd() {
    var p = document.querySelector('cart-drawer [data-t22c-tillagd]');
    if (!p) return;
    if (senaste && (p.hidden || p.textContent !== senaste)) { p.textContent = senaste; p.hidden = false; }
  }
  function patchaLadan() {
    var C = customElements.get('cart-drawer');
    if (!C || C.prototype.t22Patchad) return;
    var orig = C.prototype.renderContents;
    C.prototype.renderContents = function (parsedState) {
      senaste = tillagdText(parsedState);
      var r = orig.apply(this, arguments);
      visaTillagd();
      return r;
    };
    var origClose = C.prototype.close;
    C.prototype.close = function () {
      senaste = '';
      return origClose.apply(this, arguments);
    };
    C.prototype.t22Patchad = true;
    document.querySelectorAll('cart-drawer').forEach(function (d) {
      new MutationObserver(function () { if (senaste) visaTillagd(); }).observe(d, { childList: true, subtree: true });
    });
  }

  function start() {
    if (window.customElements) customElements.whenDefined('cart-drawer').then(patchaLadan);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source !== 'cart-items') bort = null;
        bortRad();
        aterstall();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
